var map = {
	"./404.svg": 93236,
	"./Pause.svg": 17254,
	"./arrow-ios-down.svg": 14253,
	"./arrow-ios-left.svg": 80601,
	"./arrow-ios-right.svg": 81831,
	"./arrow-ios-up.svg": 22418,
	"./arrow-left.svg": 10995,
	"./arrow-right-1.svg": 48090,
	"./arrow-right-2.svg": 33065,
	"./arrow-right-orange.svg": 8013,
	"./arrow-right.svg": 49417,
	"./attendees.svg": 84334,
	"./award.svg": 52589,
	"./blog-abst.svg": 95749,
	"./blogger.svg": 79769,
	"./calendar-o.svg": 3286,
	"./calendar-w.svg": 4568,
	"./calendar.svg": 48757,
	"./call-o.svg": 36325,
	"./cancel-w.svg": 19587,
	"./chat-dsc-2.svg": 95441,
	"./chat-dsc.svg": 78160,
	"./chat.svg": 35638,
	"./chatbubble.svg": 78281,
	"./check-o.svg": 18990,
	"./checkmark.svg": 19197,
	"./chevron-left.svg": 99546,
	"./chevron-right.svg": 8848,
	"./clock-o.svg": 84667,
	"./clock.svg": 53913,
	"./close.svg": 95775,
	"./comment-2.svg": 95320,
	"./comment.svg": 41438,
	"./contribution.svg": 74010,
	"./cookies.svg": 92380,
	"./digital.svg": 82029,
	"./direction.svg": 41521,
	"./dislike.svg": 86206,
	"./disliked.svg": 92666,
	"./download.svg": 67791,
	"./dropdown-icon-down-white.svg": 44141,
	"./dropdown-icon-down.svg": 91826,
	"./dropdown-icon-right-2.svg": 60594,
	"./dropdown-icon-right.svg": 83241,
	"./edit-w.svg": 73832,
	"./edit.svg": 48883,
	"./elmnt-1.svg": 84071,
	"./elmnt-2.svg": 62152,
	"./email.svg": 27974,
	"./embed.svg": 94469,
	"./facebook-blue.svg": 8142,
	"./facebook.svg": 39509,
	"./family.svg": 1339,
	"./feature-1.svg": 22639,
	"./feature-2.svg": 98860,
	"./feature-3.svg": 24078,
	"./globe.svg": 33516,
	"./heart-fill-o.svg": 64118,
	"./heart-fill.svg": 82110,
	"./heart-o-orange.svg": 31279,
	"./heart.svg": 33858,
	"./instagram.svg": 14962,
	"./language.svg": 58702,
	"./like.svg": 74330,
	"./liked.svg": 75734,
	"./linkedin.svg": 59466,
	"./list-2.svg": 27887,
	"./list.svg": 89700,
	"./location-o.svg": 14127,
	"./logout.svg": 72827,
	"./megamenu-1.svg": 62807,
	"./megamenu-2.svg": 75223,
	"./megamenu-3.svg": 12679,
	"./megamenu-4.svg": 67369,
	"./menu.svg": 70978,
	"./mic.svg": 82069,
	"./note.svg": 31175,
	"./notification.svg": 36577,
	"./people.svg": 88323,
	"./phone.svg": 96107,
	"./play-btn-2.svg": 80599,
	"./play-btn.svg": 63082,
	"./play-icon-2.svg": 26373,
	"./play-icon.svg": 59233,
	"./play-round-text.svg": 15113,
	"./play.svg": 92768,
	"./popper.svg": 40483,
	"./profile.svg": 23216,
	"./quote-left.svg": 36513,
	"./reddit.svg": 68987,
	"./search.svg": 62377,
	"./settings.svg": 56025,
	"./share-orange.svg": 68587,
	"./share.svg": 77283,
	"./signupIcons/12-29.svg": 90339,
	"./signupIcons/30-39.svg": 29073,
	"./signupIcons/40-49.svg": 85232,
	"./signupIcons/50-Plus.svg": 71048,
	"./signupIcons/angry.svg": 54389,
	"./signupIcons/days/Afternoon.svg": 25853,
	"./signupIcons/days/Evening.svg": 44332,
	"./signupIcons/days/Morning.svg": 36634,
	"./signupIcons/days/Night.svg": 1978,
	"./signupIcons/elevate/Communication.svg": 83040,
	"./signupIcons/elevate/Emotions.svg": 50409,
	"./signupIcons/elevate/Empathy.svg": 15377,
	"./signupIcons/elevate/Exercise.svg": 64483,
	"./signupIcons/elevate/Habits.svg": 76826,
	"./signupIcons/elevate/Leadership.svg": 23067,
	"./signupIcons/elevate/Management.svg": 56121,
	"./signupIcons/elevate/Mindset.svg": 39114,
	"./signupIcons/elevate/Motivation.svg": 84999,
	"./signupIcons/elevate/Nutrition.svg": 44488,
	"./signupIcons/elevate/Parenting.svg": 78239,
	"./signupIcons/elevate/Planning.svg": 1785,
	"./signupIcons/elevate/Self-Care.svg": 68573,
	"./signupIcons/elevate/Self-Confidance.svg": 86348,
	"./signupIcons/elevate/Time-Management.svg": 68991,
	"./signupIcons/female.svg": 47797,
	"./signupIcons/goals/Family.svg": 27248,
	"./signupIcons/goals/Healthcare.svg": 58335,
	"./signupIcons/goals/Loved-Ones.svg": 20354,
	"./signupIcons/goals/Money.svg": 82254,
	"./signupIcons/goals/Productive.svg": 93717,
	"./signupIcons/goals/Social-Work.svg": 13819,
	"./signupIcons/goals/Win.svg": 49557,
	"./signupIcons/goals/happy.svg": 85257,
	"./signupIcons/happy.svg": 19502,
	"./signupIcons/issues/Ageing.svg": 30428,
	"./signupIcons/issues/Birth.svg": 24410,
	"./signupIcons/issues/Desire-1.svg": 49480,
	"./signupIcons/issues/Desire-2.svg": 32836,
	"./signupIcons/issues/Loved-Ones.svg": 61133,
	"./signupIcons/issues/Pleasure.svg": 45055,
	"./signupIcons/issues/Sickness.svg": 94349,
	"./signupIcons/issues/SubhashChandraShow.svg": 8714,
	"./signupIcons/issues/Want.svg": 65131,
	"./signupIcons/male.svg": 51416,
	"./signupIcons/noEmotion.svg": 13315,
	"./signupIcons/other.svg": 73410,
	"./signupIcons/sad.svg": 34372,
	"./signupIcons/tired.svg": 49981,
	"./spotify.svg": 75891,
	"./star-effect.svg": 81124,
	"./star.svg": 66982,
	"./success-tick.svg": 18983,
	"./support.svg": 97633,
	"./task-square.svg": 57884,
	"./telegram.svg": 77099,
	"./thoughtOftheDay-Icon.svg": 90628,
	"./thoughtOftheDay.svg": 91482,
	"./trash.svg": 73466,
	"./twitter.svg": 26717,
	"./user-o.svg": 95581,
	"./video.svg": 67798,
	"./youtube.svg": 81307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63131;